<template>
	<client-only>
		<div v-show="isShow" :class="[isMobile ? 'h-[3.25rem] text-14 leading-5' : 'h-9 hidden tablet:flex']" class="bar flex justify-center items-center order-first bg-goPink text-white font-bold text-center">
			<nuxt-link :to="promoBar.url" class="hover:opacity-90 active:opacity-80 py-6 px-12 mx-32 transition-opacity">
				<div class="flex items-center justify-center">
					<img v-if="promoBar.icon.data" :src="promoBar.icon.data.attributes.url" :class="[isMobile ? 'mr-8' : 'mr-10']" width="20" height="20" :alt="promoBar.icon.data.attributes.alternativeText || 'Promo icon'">
					<p :class="[isMobile && 'max-w-[260px]']" class="break-words whitespace-normal">{{ promoBar.title }}</p>
				</div>
			</nuxt-link>
			<button class="absolute right-6 p-6 opacity-50" aria-label="Hide promo bar" @click="onHide">
				<svg-icon name="x" title="Close" class="iconSize-24" />
			</button>
		</div>
	</client-only>
</template>

<script>
export default {
	props: {
		isShow: {
			type: Boolean,
			required: true,
		},
		isMobile: {
			type: Boolean,
			default: false,
		},
		promoBar: {
			type: Object,
			required: true,
		},
		onHide: {
			type: Function,
      		required: true
		},

	},
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 360px) {
	.bar {
		font-size: 0.75rem;
	}
	.tag-icon {
		width: 1rem;
		height: 1rem;
	}
}
</style>
